<script setup lang="tsx">
import methodEditor from '@/stores/method-editor'
import jiraCbStore from '@/stores/jira-checkboxes'
import { computed } from 'vue'
import IconButton from '@/components/shared/IconButton.vue'
import { hasPermission } from '@/services/utils'
import { PermAllMeasureWrite, PermOwnMeasureWrite } from '@/models/enums-generated'

const editor = methodEditor()
const jiraStore = jiraCbStore()

const isJiraMode = computed(() => {
	return jiraStore.isJiraMode
})
</script>

<template>
	<IconButton
		v-if="!isJiraMode && hasPermission(PermAllMeasureWrite, PermOwnMeasureWrite)"
		id="edit-methods-btn"
		class="bi bi-pencil"
		:title="$t('misc.edit')"
		@click="editor.isEditMode = !editor.isEditMode"
		><slot></slot
	></IconButton>
</template>
